var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommended18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7652 10.8824C11.3479 11.8142 11.6978 13.1336 11.6835 14.6471C12.1427 14.6471 18.5712 9 15.8161 1C12.6019 1.94118 8.01013 5.70588 7.55095 8.05882C8.35704 8.28494 9.23625 8.89294 9.84684 9.47059C10.306 8.05882 12.1427 6.17647 13.5202 5.23529C12.1427 7.11765 11.2244 8.52941 10.7652 10.8824ZM2.5 9.00001C2.95918 13.2353 5.25506 16.5294 8.92846 17C8.92846 14.6471 6.17341 11.353 5.25506 10.8824C8.01011 11.353 9.84682 13.7059 10.7652 16.5294C10.7652 16.5294 11.2243 7.11766 2.5 9.00001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommended18);
export default __webpack_public_path__ + "d4246c0f9ddcdc588cf9b8405b9c3637.svg";
export { ForwardRef as ReactComponent };